export const FETCH_TODOS = "FETCH_PDFLIST";

//PALMS
export const FETCH_SCORE = "FETCH_SCORE";
export const FETCH_PDFLIST = "FETCH_PDFLIST";
